import { SHGrid, SHStack } from "@components/design-systems";
import { MSFilterColumn } from "@pages/managed-accounts/model-screener/components/model-screener-table/toolbar/filter/filter-columns/column";
import { isEmpty } from "lodash";
import { ModelScreenerFilterColumnDTO } from "@models/model-screener/entities/modelScreenerFilter";

type MSTableFilterColumnLayoutProps = {
  columns?: ModelScreenerFilterColumnDTO[];
  disabled?: boolean;
};

export const MSTableFilterColumnLayout = ({
  columns,
  disabled
}: MSTableFilterColumnLayoutProps) => {
  const renderColumns = () => {
    if (!columns || isEmpty(columns)) return null;

    return (
      <>
        {columns.map((column, index) => (
          <SHStack
            key={index}
            height={"100%"}
            width={"100%"}
            direction={"column"}
            gap={1.5}
          >
            <MSFilterColumn column={column} disabled={disabled}/>
          </SHStack>
        ))}
      </>
    );
  };

  return (
    <SHGrid
      container
      width={"100%"}
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(4, 1fr)",
        gap: "15px",
        boxSizing: "border-box",
      }}
    >
      {renderColumns()}
    </SHGrid>
  );
};
